.grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  background: var(--bg-panel);
  border-radius: var(--r-14);
  overflow: hidden;
}

.mapPlaceholder {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--border-1);
  color: var(--text-muted);
  font-size: 13px;
  text-decoration: none;
  border-bottom: 1px solid var(--border-4);
}

.cardBody {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.venueName {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 21px;
}

.address {
  font-size: 15px;
}

.contactLine {
  font-size: 14px;
  color: var(--text-muted);
}
.contactLine a {
  text-decoration: none;
}

.directions {
  margin-top: 6px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}

.actionRow {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 0 14px 14px;
}

.actionPrimary,
.actionSecondary {
  height: 48px;
  border-radius: var(--r-10);
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.actionPrimary {
  background: var(--bg-dark);
  color: var(--text-on-dark);
}

.actionSecondary {
  border: 1px solid var(--border-4);
  color: var(--text-primary);
}

.amenityChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.amenityChip {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: var(--r-pill);
  background: var(--bg-panel);
  font-size: 13px;
  color: var(--text-secondary);
}
.amenityChip svg {
  color: var(--success-text);
  flex-shrink: 0;
}

.hotelLabel {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.hotelInfo {
  font-size: 14px;
  line-height: 1.5;
}
.hotelInfo p {
  margin: 0 0 8px;
}
.hotelInfo p:last-child {
  margin-bottom: 0;
}

@media (min-width: 1200px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  /* Desktop.dc.html's map placeholder is 140px, vs mobile's 130px. */
  .mapPlaceholder {
    height: 140px;
  }
}
